import NextFiveDays from "./next-five-days";
import TodayContent from "./today-card/today-content";

const Upcoming = () => {
  return (
    <>
      <h1 className="resource-title-upcoming">Upcoming</h1>
      <div className="homepage-top">
        <TodayContent />
        <NextFiveDays />
      </div>
    </>
  );
};

export default Upcoming;
